import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root',
})
export class ManipulatorPcvizService {
    getManipulator(): typeof PointCloudViz.Manipulator {
        return PointCloudViz.Manipulator;
    }
}
